import { Controller } from "@hotwired/stimulus"
import { taxNoKindPlaceholder } from "./helpers/tax_no"

export default class extends Controller {
  static targets = ["taxNo", "taxNoKind", "shortcutName", "postalAddressWrapper"]

  connect() {
    console.log("client connect", this.element)
    this.kindChanged()
  }

  kindChanged() {
    if (!this.hasTaxNoKindTarget || !this.hasTaxNoTarget) return
    taxNoKindPlaceholder(this.taxNoKindTarget, this.taxNoTarget)
  }

  switchType(event) {
    if (event.target.value === "true") {
      document.querySelectorAll("[data-company]").forEach((element) => element.classList.remove("hidden"))
      document.querySelector("#client_name").closest("[data-company]").after(this.taxNoTarget)
    } else {
      document.querySelectorAll("[data-company]").forEach((element) => element.classList.add("hidden"))
      document.querySelector("#client_last_name").closest("div").after(this.taxNoTarget)
    }
  }

  setShortcut(event) {
    if (this.hasShortcutNameTarget && this.shortcutNameTarget.value === "") {
      this.shortcutNameTarget.value = event.currentTarget.value
    }
  }

  clearPostalAddressForm() {
    const wrapper = this.postalAddressWrapperTarget
    wrapper.querySelectorAll('input[type="text"], textarea').forEach(el => {
      if (!['#delivery_address_old'].includes(`#${el.id}`)) {
        el.value = ''
      }
    })
    wrapper.querySelectorAll('select').forEach(el => {
      el.selectedIndex = 0
    })
  }

  updatePostalAddressVisibility(event) {
    const isChecked = event.target.checked
    this.postalAddressWrapperTarget.classList.toggle("hidden", !isChecked)
  }
}
